/**
 * Landing page accent palette.
 *
 * Used in inline `style={}` props and SVG attributes where CSS custom
 * properties aren't convenient (e.g. `stroke`, `fill`, gradient strings).
 *
 * All values must stay in sync with the `--color-accent-*` variables
 * defined in `.qosm-dark` in globals.css.
 *
 * To re-theme the landing page, update both this file and globals.css.
 */

export const accent = {
  /** Primary accent — labels, icons, active states */
  DEFAULT: "#c4b5fd",
  /** Brighter variant — hover states */
  bright: "#ddd6fe",
  /** Darker variant — pressed states, dimmed accent */
  dim: "#a78bfa",
  /** Text color on solid accent background (buttons) */
  onAccent: "#0f0a1e",
  /** Low-opacity background — badges, icon containers */
  subtle: "rgba(196,181,253,0.10)",
  /** Very low-opacity glow — hero radial gradient */
  glow: "rgba(139,92,246,0.10)",
  /** Ring/outline on featured cards */
  ring: "rgba(139,92,246,0.12)",
  /** Tinted dots in the hero starfield */
  star: "rgba(196,181,253,0.25)",
  /** Faint shadow behind code panels */
  shadow: "rgba(139,92,246,0.08)",
  /** Pulsing dot for "coming soon" indicators */
  pulse: "rgba(167,139,250,0.50)",
} as const;
